<template>
  <view-wrap class="bg-light">
    <div id="about">
      <h1 class="caps">About Us</h1>
      <p>We're a group of friends in Toronto that enjoy fantasy sports.</p>
      <p>We found ourselves spending hours every week analyzing our Fantasy Basketball stats (copy pasting off of Yahoo, using funky formulas, and so on).</p>
      <p>The existing fantasy sports tools seem to focus on drafting or analyzing trades, which is helpful but not exactly what we needed. They were also
        pretty pricey. We decided to try and make something in our spare time that was simple, informative and affordable.</p>
      <p>We're always open to feedback or suggestions, so please do <router-link :to="{name: 'contact'}">reach out!</router-link></p>
      <br>
      <br>
      <h3 class="caps">Support our work</h3>
      <p>Currently, our biggest expense is server costs. There's a lot that goes on in the background. If you'd like to help support this site you can use the link below to buy us a ☕️.</p>
      <buy-me-a-coffee></buy-me-a-coffee>
    </div>
  </view-wrap>
</template>

<script>
  import buyMeACoffee from '@/components/buy-me-a-coffee/buy-me-a-coffee.vue'
  export default {
    name: "about",
    data () {
      return {}
    },
    components: {
      'buy-me-a-coffee': buyMeACoffee
    },
    methods: {}
  };
</script>

<style src="./about.styl" lang="stylus" scoped></style>
